import React from 'react'
import { ProducedBlockItem } from './ProducedBlockItem'
import { Transaction } from '../../../app/models/generated'
import styles from '../BlocksPage/index.module.sass'
interface TransactionArrayInterface {
    TransactionArray: Array<Transaction>
}

export const ProducedBlockItems = ({
    TransactionArray,
}: TransactionArrayInterface) => {
    return (
        <tbody className={styles.tableBody}>
            {TransactionArray.map((transaction: Transaction) => {
                return (
                    <ProducedBlockItem
                        key={transaction.hash}
                        transaction={transaction}
                    />
                )
            })}
        </tbody>
    )
}
